// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ct5Z","colBig":"styles_colBig__3em5I","colSmall":"styles_colSmall__1T6IU","shopifyNameWrapper":"styles_shopifyNameWrapper__2d65F"};